import * as React from "react";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { componentWithProps } from "../generic/componentWithProps";
import { ProgressWithSkip } from "../generic/progress-with-skip/ProgressWithSkip";
import { ResourceBar } from "../generic/resource-bar/ResourceBar";
import { TextLoca } from "../generic/text/TextLoca";
export var QuickSkipDialogWrapper = React.memo(function (_a) {
    var remainingTime = _a.remainingTime, onCancel = _a.onCancel, title = _a.title, description1 = _a.description1, description2 = _a.description2, locaReplacements = _a.locaReplacements, onSkip = _a.onSkip, skipProcessFactor = _a.skipProcessFactor, processTotalTime = _a.processTotalTime, icon = _a.icon;
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: [IdResource.Money, IdResource.Gold],
    });
    return (React.createElement(DialogWrapper, { titleLocaId: title, onClose: onCancel, className: IdStyles.ModalBackgroundResources, footerRenderer: footerComponent },
        React.createElement("div", { className: "quick-skip-dialog-container" },
            React.createElement(TextLoca, { className: IdStyles.TextNormal, id: description1 }),
            React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: description2, replacements: locaReplacements }),
            React.createElement(ProgressWithSkip, { icon: icon, remainingTime: remainingTime, onSkip: onSkip, skipProcessFactor: skipProcessFactor, duration: processTotalTime }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/QuickSkipDialogWrapper.tsx
// module id = 955
// module chunks = 3